import React, { Component } from 'react';
import { Row, Col, Card, Skeleton, Button, Input, DatePicker, Upload, Icon, Radio, Modal } from 'antd';
import FormModal from '../../components/FormModal2';
import { app, api } from "../../app";
import locale from 'antd/lib/date-picker/locale/zh_CN';
import config from "../../config";

const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;

function normFile (e) {
    if (Array.isArray(e)) {
        return e;
    }
    return e && e.fileList;
}

function beforeUpload (file) {
    let format = ['image/jpeg', 'image/jpg', 'image/png'];
    const is = format.indexOf(file.type) > -1;
    if (!is) {
        app.alert('仅可上传文件类型为: ' + format.join("、"), 'warn');
        return Promise.reject();
    }
    return Promise.resolve();
}

class TETeamGrant extends Component {
    constructor (props) {
        super(props);
        this.state = {
            data_loading: true,
            dataInfo: {},
            if_long: "1",
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleGrantData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    async componentWillReceiveProps (props) {
        let { team } = this.props;
        if (team.teamno !== props.team.teamno) {
            let state = {
                dataInfo: {},
                if_long: "1",
                data_loading: true,
            };
            await this.setData(state);
            await this.handleGrantData();
        }
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 授权数据
     * @returns {Promise<void>}
     */
    handleGrantData = async () => {
        let { team } = this.props, params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            teamno: team.teamno
        }, { flag, data, msg } = await app.post(api.TeamAuthorize, params);
        let state = { data_loading: false };
        if (flag === 1) {
            state.dataInfo = data;
        } else {
            app.alert(msg, "error");
        }
        await app.sleep();
        this.setData(state);
    };

    /**
     * 提交信息
     * @param values
     */
    handleSubmit = async (values) => {
        if (this.state.add_loading) return;
        await this.setData({ add_loading: true });
        let { team } = this.props, { form_type, up_img } = this.state;
        values.indexno = app.getData("indexno");
        values.account = app.getData("account");
        values.teamno = team.teamno;
        values.type = form_type;
        values.authorize_img = up_img;
        if (form_type === 1) {
            values.authorize_start_time = values.authorize_time[0].format("YYYY-MM-DD");
            values.authorize_end_time = values.authorize_time[1].format("YYYY-MM-DD");
            delete values.authorize_time;
        } else {
            if (values.if_long === "2") {
                values.authorize_start_time = values.authorize_time[0].format("YYYY-MM-DD");
                values.authorize_end_time = values.authorize_time[1].format("YYYY-MM-DD");
                delete values.authorize_time;
            }
        }
        let { flag, msg } = await app.post(api.TeamAuthorizeAdd, values);
        let state = { add_loading: false };
        if (flag === 1) {
            app.alert("提交成功", "success");
            this.handleCloseForm();
        } else {
            app.alert(msg, "error");
        }
        this.setData(state);
    };

    /**
     * 打开表单
     * @param form_type
     */
    handleOpenForm = (form_type) => {
        this.setData({ form_type, form_visible: true });
    };

    /**
     * 关闭表单
     */
    handleCloseForm = () => {
        this.setData({ form_visible: false, up_img: '' });
    };

    /**
     * 图片上传变更
     * @param info
     */
    handleImgUploadChage = ({ file }) => {
        if (file.status === 'uploading') {
            this.setData({ up_loading: true });
            return;
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            this.setData({ up_img: file.response.data.url, up_loading: false });
        }
    };

    /**
     * 显示详情
     * @param type
     * @param info
     */
    handleShowDetail = (type, info) => {
        let content = null, status = info.status === "1" ? "已获取" : "已过期";
        if (type === 1) {
            content = (
                <div>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>被授权人</Col>
                        <Col span={18} offset={1}>{info.name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>授权单位</Col>
                        <Col span={18} offset={1}>{info.authorize_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>授权状态</Col>
                        <Col span={18} offset={1}>{status}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>授权时间</Col>
                        <Col span={18}
                             offset={1}>{info.authorize_start_time + " ~ " + info.authorize_end_time + " " + info.maturity}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>授权证明</Col>
                        <Col span={18} offset={1}>
                            <a href={config.imgUrl + info.authorize_img}>
                                <img src={config.imgUrl + info.authorize_img} alt=""
                                     style={{ width: "100%", height: "auto" }}/>
                            </a>
                        </Col>
                    </Row>
                </div>
            );
        } else {
            content = (
                <div>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>法人代表</Col>
                        <Col span={18} offset={1}>{info.name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>注册名称</Col>
                        <Col span={18} offset={1}>{info.authorize_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>信用编码</Col>
                        <Col span={18} offset={1}>{info.credit_code}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>发证机关</Col>
                        <Col span={18} offset={1}>{info.issuing_unit}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>注册状态</Col>
                        <Col span={18} offset={1}>{status}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>营业期限</Col>
                        <Col span={18}
                             offset={1}>{info.if_long === "1" ? "长期" : (info.authorize_start_time + " ~ " + info.authorize_end_time + " " + info.maturity)}</Col>
                    </Row>
                    <Row style={{ marginBottom: 18 }}>
                        <Col span={5}>注册证明</Col>
                        <Col span={18} offset={1}>
                            <a href={config.imgUrl + info.authorize_img} target="_blank">
                                <img src={config.imgUrl + info.authorize_img} alt=""
                                     style={{ width: "100%", height: "auto" }}/>
                            </a>
                        </Col>
                    </Row>
                </div>
            );
        }
        Modal.info({
            title: "查看详细信息",
            okText: "确定",
            centered: true,
            maskClosable: true,
            width: 600,
            content,
        })
    };

    render () {
        let { dataInfo, data_loading, form_visible, form_type, add_loading, up_img, up_loading, if_long } = this.state,
            brand = dataInfo.brand || {},
            register = dataInfo.register || {},
            skeletonOpt = {
                loading: data_loading,
                avatar: { size: "large", shape: "square" },
                paragraph: { rows: 3 },
                active: true
            },
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 16, offset: 1 },
            },
            formObj = [],
            brandColor = "#CCCCCC",
            brandState = "未获取",
            brandActions = [<Button
                onClick={() => this.handleShowDetail(1, brand)}>查看详细信息</Button>,
                <Button type="primary" onClick={() => this.handleOpenForm(1)}>重新上传</Button>],
            registerColor = "#CCCCCC",
            registerState = "未获取",
            registerActions = [<Button
                onClick={() => this.handleShowDetail(2, register)}>查看详细信息</Button>,
                <Button type="primary" onClick={() => this.handleOpenForm(2)}>重新上传</Button>];
        if (brand.status === "1") {
            brandColor = "#8CC96A";
            brandState = "已获取";
        } else if (brand.status === "2") {
            brandColor = "#EC9A39";
            brandState = "已过期";
        } else {
            brandActions = [<Button type="primary" onClick={() => this.handleOpenForm(1)}>上传信息</Button>];
        }
        if (register.status === "1") {
            registerColor = "#E38888";
            registerState = "已获取";
        } else if (register.status === "2") {
            registerColor = "#EC9A39";
            registerState = "已过期";
        } else {
            registerActions = [<Button type="primary" onClick={() => this.handleOpenForm(2)}>上传信息</Button>];
        }
        if (form_visible) {
            if (form_type === 1) {
                formObj.push(
                    {
                        formItemLayout,
                        label: "被授权人",
                        name: "name",
                        options: {
                            rules: [
                                { required: true, message: '请填写授权人' },
                            ]
                        },
                        component: (
                            <Input/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "授权单位",
                        name: "authorize_name",
                        options: {
                            rules: [
                                { required: true, message: '请填写授权单位' },
                            ]
                        },
                        component: (
                            <Input/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "授权时间",
                        name: "authorize_time",
                        options: {
                            rules: [
                                { type: 'array', required: true, message: '请选择授权时间' },
                            ]
                        },
                        component: (
                            <RangePicker locale={locale}/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "授权证明",
                        name: "authorize_img",
                        options: {
                            rules: [
                                { required: true, message: '请上传图片' },
                            ],
                            valuePropName: 'fileList',
                            getValueFromEvent: normFile,
                        },
                        component: (
                            <Upload action={config.serverUrl + api.ImageUpload}
                                    accept='image/jpeg, image/jpg, image/png'
                                    data={{
                                        token: app.getData('token'),
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        upload_type: 'team',
                                    }}
                                    name="image"
                                    onChange={this.handleImgUploadChage}
                                    beforeUpload={beforeUpload}
                                    listType="picture-card"
                                    showUploadList={false}
                            >
                                {up_img ?
                                    <img src={config.imgUrl + up_img} style={{ width: 86, height: 86 }} alt="证书"/> :
                                    (
                                        <div>
                                            <Icon type={up_loading ? 'loading' : 'plus'}/>
                                            <div className="ant-upload-text">上传</div>
                                        </div>
                                    )}
                            </Upload>
                        )
                    }
                );
            } else {
                formObj.push(
                    {
                        formItemLayout,
                        label: "法人代表",
                        name: "name",
                        options: {
                            rules: [
                                { required: true, message: '请填写法人代表' },
                            ]
                        },
                        component: (
                            <Input/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "注册名称",
                        name: "authorize_name",
                        options: {
                            rules: [
                                { required: true, message: '请填写注册名称' },
                            ]
                        },
                        component: (
                            <Input/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "信用编码",
                        name: "credit_code",
                        options: {
                            rules: [
                                { required: true, message: '请填写信用编码' },
                            ]
                        },
                        component: (
                            <Input/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "发证机关",
                        name: "issuing_unit",
                        options: {
                            rules: [
                                { required: true, message: '请填写发证机关' },
                            ]
                        },
                        component: (
                            <Input/>
                        )
                    },
                    {
                        formItemLayout,
                        label: "是否长期",
                        name: "if_long",
                        options: {
                            rules: [
                                { required: true, message: '请选择是否长期' },
                            ], initialValue: "1"
                        },
                        component: (
                            <RadioGroup onChange={(e) => {
                                this.setData({ if_long: e.target.value })
                            }}>
                                <Radio value="1">是</Radio>
                                <Radio value="2">否</Radio>
                            </RadioGroup>
                        )
                    },
                    {
                        formItemLayout,
                        label: "注册证明",
                        name: "authorize_img",
                        options: {
                            rules: [
                                { required: true, message: '请上传图片' },
                            ],
                            valuePropName: 'fileList',
                            getValueFromEvent: normFile,
                        },
                        component: (
                            <Upload action={config.serverUrl + api.ImageUpload}
                                    accept='image/jpeg, image/jpg, image/png'
                                    data={{
                                        token: app.getData('token'),
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        upload_type: 'team',
                                    }}
                                    name="image"
                                    onChange={this.handleImgUploadChage}
                                    beforeUpload={beforeUpload}
                                    listType="picture-card"
                                    showUploadList={false}
                            >
                                {up_img ?
                                    <img src={config.imgUrl + up_img} style={{ width: 86, height: 86 }} alt="证书"/> :
                                    (
                                        <div>
                                            <Icon type={up_loading ? 'loading' : 'plus'}/>
                                            <div className="ant-upload-text">上传</div>
                                        </div>
                                    )}
                            </Upload>
                        )
                    }
                );
                if (if_long !== "1") {
                    formObj.splice(5, 0, {
                        formItemLayout,
                        label: "营业期限",
                        name: "authorize_time",
                        options: {
                            rules: [
                                { type: 'array', required: true, message: '请选择营业期限' },
                            ]
                        },
                        component: (
                            <RangePicker locale={locale}/>
                        )
                    });
                }
            }
        }
        return (
            <div className="team-grant">
                <h2 className="title">注册信息</h2>
                <Row gutter={20}>
                    {/*<Col span={12}>*/}
                    {/*    <Card*/}
                    {/*        bodyStyle={{ padding: 12, height: 228 }}*/}
                    {/*        actions={data_loading ? [] : brandActions}*/}
                    {/*    >*/}
                    {/*        <Skeleton {...skeletonOpt}>*/}
                    {/*            <div className="info">*/}
                    {/*                <i className="iconfont icon-yihuodepinpaishouquan1" style={{ color: brandColor }}/>*/}
                    {/*                <span className="i-names">*/}
                    {/*                <Row className="in1" type="flex" justify="space-between">*/}
                    {/*                    <Col className="name">品牌授权信息</Col>*/}
                    {/*                    <Col className="over" hidden={!brand.status}>{brand.maturity}</Col>*/}
                    {/*                </Row>*/}
                    {/*                <div className="state" style={{ color: brandColor }}>{brandState}</div>*/}
                    {/*            </span>*/}
                    {/*            </div>*/}
                    {/*            <div className="c1">被授权人： {brand.name || '-'}</div>*/}
                    {/*            <div className="c1">授权单位： {brand.authorize_name || '-'}</div>*/}
                    {/*            <div*/}
                    {/*                className="c1">授权时间： {brand.status ? (brand.authorize_start_time + " ~ " + brand.authorize_end_time) : '-'}</div>*/}
                    {/*        </Skeleton>*/}
                    {/*    </Card>*/}
                    {/*</Col>*/}
                    <Col span={12}>
                        <Card
                            bodyStyle={{ padding: 12, height: 228 }}
                            actions={data_loading ? [] : registerActions}
                        >
                            <Skeleton {...skeletonOpt}>
                                <div className="info">
                                    <i className="iconfont icon-minzhengzhucexinxi1" style={{ color: registerColor }}/>
                                    <span className="i-names">
                                    <Row className="in1" type="flex" justify="space-between">
                                        <Col className="name">法人注册信息</Col>
                                        <Col className="over" hidden={!register.status}>{register.maturity}</Col>
                                    </Row>
                                    <div className="state" style={{ color: registerColor }}>{registerState}</div>
                                </span>
                                </div>
                                <div className="c1">发证机关： {register.issuing_unit || '-'}</div>
                                <div className="c1">注册名称： {register.authorize_name || '-'}</div>
                                <div className="c1">法人代表： {register.name || '-'}</div>
                                <div className="c1">信用编码： {register.credit_code || '-'}</div>
                            </Skeleton>
                        </Card>
                    </Col>
                </Row>
                <FormModal
                    modal={{
                        visible: form_visible,
                        title: form_type === 1 ? "上传授权信息" : "上传法人注册信息",
                        onCancel: this.handleCloseForm,
                        okText: "确认",
                        cancelText: "取消",
                        confirmLoading: add_loading,
                        maskClosable: false,
                        destroyOnClose: true,
                        style: { top: "15%" }
                    }}
                    onSubmit={this.handleSubmit}
                    children={formObj}
                    other={<div style={{color: "red"}}>注：上传授权信息需要省级管理员审核通过方可展示。</div>}
                />
            </div>
        );
    }
}

export default TETeamGrant;



// WEBPACK FOOTER //
// ./src/routes/ranks/TETeamGrant.jsx